<template>
  <f7-popup id="changepassword" @popup:opened="open">
    <f7-view>
      <f7-pages>
        <f7-page navbar-fixed toolbar-fixed>
          <f7-navbar>
            <f7-nav-left>
              <f7-link close-popup>Cancel</f7-link>
            </f7-nav-left>
            <f7-nav-center>Change Password</f7-nav-center>
            <f7-nav-right>
              <f7-link @click="save">Save</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <!-- <f7-block-title>Device operations</f7-block-title> -->
          <f7-list form>
            <f7-list-item title="Username">
              <div slot="after">
                <f7-input
                  name="username2"
                  id="username2"
                  type="text"
                  v-model="username"
                  :disabled="true"></f7-input>
              </div>
            </f7-list-item>
            <f7-list-item title="Current password">
              <div slot="after">
                <f7-input
                  name="currentpass"
                  id="currentpass"
                  type="password"
                  v-model="currentpass"
                  placeholder=""></f7-input>
              </div>
            </f7-list-item>
            <f7-list-item title="New password">
              <div slot="after">
                <f7-input
                  name="newpass"
                  id="newpass"
                  type="password"
                  v-model="newpass"
                  placeholder=""></f7-input>
              </div>
            </f7-list-item>
            <f7-list-item title="New password, again">
              <div slot="after">
                <f7-input
                  name="newpassagain"
                  id="newpassagain"
                  type="password"
                  v-model="newpassagain"
                  placeholder=""></f7-input>
              </div>
            </f7-list-item>
          </f7-list>
        </f7-page>
      </f7-pages>
    </f7-view>
  </f7-popup>
</template>

<script>
import Settings from '../settings'
const maiurl = 'http://' + Settings.host + ':5151'

export default {
  data () {
    return {
      username: '',
      currentpass: '',
      newpass: '',
      newpassagain: ''
    }
  },
  name: 'ChangePassword',
  methods: {
    open () {
      var user = JSON.parse(localStorage.getItem('user'))
      console.log('CP', user)
      this.username = user.username
      this.currentpass = ''
      this.newpass = ''
      this.newpassagain = ''
    },
    save () {
      var vm = this

      if (this.currentpass === '' || this.newpass === '' || this.newpassagain === '') {
        this.$f7.alert(
          'Please fill all the fields.',
          'Error'
        )
        return
      }
      if (this.newpass !== this.newpassagain) {
        this.$f7.alert(
          'Two passwords are not the same, please check.',
          'Error'
        )
        return
      }
      this.$http.post(maiurl + '/change_pass', {currentpass: this.currentpass, newpass: this.newpass}, { emulateJSON: true }
      ).then(response => {
        if (response.body === '1') {
          localStorage.removeItem('user')
          this.$f7.alert(
            'Password changed. Please re-login with new password',
            'Success',
            function () { location.reload() }
          )
          vm.$f7.closeModal('#changepassword')
        } else {
          this.$f7.alert(
            'Current password is not correct.',
            'Error'
          )
        }
        console.log(response)
      }, response => {
        console.log(response)
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue